import { render, staticRenderFns } from "./RepairServicePage.vue?vue&type=template&id=a4b7b27a"
import script from "./RepairServicePage.vue?vue&type=script&lang=js"
export * from "./RepairServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports